import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';

const FilterForm = ({
  handleChange,
  handleSubmit,
  isSubmitting,
  values,
  heading = '',
  handleCloseModal,
  handleValueChange,
  onReset,
  setOpen
}) => {
  const { trainerList } = useSelector((state) => state.trainer);
  const { membershipPlanList } = useSelector((state) => state.membershipPlan);
  const { batchList } = useSelector((state) => state.batches);
  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between' }}>
        <Typography color="textPrimary" variant="h2">
          {heading}
        </Typography>
        {handleCloseModal && (
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleCloseModal} />
        )}
      </Box>
      <FormControl
        variant="outlined"
        fullWidth
        margin="normal"
        id="filterBy-select"
      >
        <InputLabel id="filterBy-label">Filter By</InputLabel>
        <Select
          labelId="filterBy-label"
          id="filterBy"
          value={values.filterBy}
          onChange={(value) => {
            handleValueChange('filterBy', value?.target?.value);
            handleChange(value);
          }}
          label="Filter By"
          name="filterBy"
        >
          <MenuItem name="filterBy" value={'Membership Plan'}>
            Membership Plan
          </MenuItem>
          <MenuItem name="filterBy" value={'Batch'}>
            Batch
          </MenuItem>
          <MenuItem name="filterBy" value={'Trainer'}>
            Trainer
          </MenuItem>
          <MenuItem name="filterBy" value={'Gender'}>
            Gender
          </MenuItem>
        </Select>
      </FormControl>
      {values.filterBy === 'Membership Plan' && (
        <FormControl
          variant="outlined"
          fullWidth
          margin="normal"
          id="membershipPlan-select"
        >
          <InputLabel id="membershipPlan-label">
            {'Select MembershipPlan'}
          </InputLabel>
          <Select
            value={values.name}
            onChange={(value) => {
              handleValueChange('name', value?.target?.value);
              handleChange(value);
            }}
            labelId="membershipPlan-label"
            id="membershipPlan"
            label="Select membershipPlan"
            name="name"
          >
            {membershipPlanList.map((membershipPlan, index) => (
              <MenuItem key={index} name="name" value={membershipPlan.name}>
                {membershipPlan.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {values.filterBy === 'Batch' && (
        <FormControl
          variant="outlined"
          fullWidth
          margin="normal"
          id="batch-select"
        >
          <InputLabel id="batch-label">{'Select batch'}</InputLabel>
          <Select
            value={values.name}
            onChange={(value) => {
              handleValueChange('name', value?.target?.value);
              handleChange(value);
            }}
            labelId="batch-label"
            id="batch"
            label="Select batch"
            name="name"
          >
            {batchList.map((batch, index) => (
              <MenuItem key={index} name="name" value={batch.name}>
                {batch.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {values.filterBy === 'Trainer' && (
        <FormControl
          variant="outlined"
          fullWidth
          margin="normal"
          id="trainer-select"
        >
          <InputLabel id="trainer-label">{'Select trainer'}</InputLabel>
          <Select
            value={values.name}
            onChange={(value) => {
              handleValueChange('name', value?.target?.value);
              handleChange(value);
            }}
            labelId="trainer-label"
            id="trainer"
            label="Select trainer"
            name="name"
          >
            {trainerList.map((trainer, index) => (
              <MenuItem key={index} name="name" value={trainer.name}>
                {trainer.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {values.filterBy === 'Gender' && (
        <FormControl
          variant="outlined"
          fullWidth
          margin="normal"
          id="gender-select"
        >
          <InputLabel id="gender-label">{'Select gender'}</InputLabel>
          <Select
            value={values.name}
            onChange={(value) => {
              handleValueChange('name', value?.target?.value);
              handleChange(value);
            }}
            labelId="gender-label"
            id="gender"
            label="Select gender"
            name="name"
          >
            <MenuItem name="name" value={0}>
              Male
            </MenuItem>
            <MenuItem name="name" value={1}>
              Female
            </MenuItem>
          </Select>
        </FormControl>
      )}
      <FormControl
        variant="outlined"
        fullWidth
        margin="normal"
        id="sortBy-select"
      >
        <InputLabel id="sortBy-label">Sort By</InputLabel>
        <Select
          labelId="sortBy-label"
          id="sortBy"
          value={values.sortBy}
          onChange={(value) => {
            handleValueChange('sortBy', value?.target?.value);
            handleChange(value);
          }}
          label="Sort By"
          name="sortBy"
        >
          <MenuItem name="sortBy" value={'Full Name'}>
            Full Name
          </MenuItem>
          <MenuItem name="sortBy" value={'Father Name'}>
            Father Name
          </MenuItem>
          <MenuItem name="sortBy" value={'Height'}>
            Height
          </MenuItem>
          <MenuItem name="sortBy" value={'Weight'}>
            Weight
          </MenuItem>
          <MenuItem name="sortBy" value={'Membership Start Date'}>
            Membership Start Date
          </MenuItem>
          <MenuItem name="sortBy" value={'Membership End Date'}>
            Membership End Date
          </MenuItem>
        </Select>
      </FormControl>

      <FormControl
        variant="outlined"
        fullWidth
        margin="normal"
        id="sortOrder-select"
      >
        <InputLabel id="sortOrder-label">Sort Order</InputLabel>
        <Select
          labelId="sortOrder-label"
          id="sortOrder"
          value={values?.sortOrder}
          onChange={(value) => {
            handleValueChange('sortOrder', value?.target?.value);
            handleChange(value);
          }}
          label="Sort Order"
          name="sortOrder"
        >
          <MenuItem name="sortOrder" value={'Ascending'}>
            Ascending
          </MenuItem>
          <MenuItem name="sortOrder" value={'Descending'}>
            Descending
          </MenuItem>
        </Select>
      </FormControl>
      <Box sx={{ py: 2 }}>
        <Button
          color="primary"
          disabled={isSubmitting}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
        >
          {'Filter'}
        </Button>
        <Button
          sx={{ marginTop: '10px' }}
          color="primary"
          disabled={isSubmitting}
          onClick={() => {
            onReset();
            setOpen();
          }}
          fullWidth
          size="large"
          type="button"
          variant="outlined"
        >
          {'Reset Filter'}
        </Button>
      </Box>
    </form>
  );
};

export default FilterForm;
